import { ref, push, set, remove } from 'firebase/database';
import { database } from '../config/firebase';
import { hashPassword, isPasswordHashed } from '../utils/authUtils';

export const useTeacherManagement = () => {
  
  const handleAddTeacher = async ({ name, username, password, isMaster }) => {
    try {
      const hashedPassword = await hashPassword(password);
      const newTeacherRef = push(ref(database, 'teachers'));
      const newTeacher = {
        id: newTeacherRef.key,
        name,
        username,
        password: hashedPassword,
        isMaster: isMaster || false,
      };
      await set(newTeacherRef, newTeacher);
      return { success: true };
    } catch (error) {
      console.error('教師の追加に失敗しました:', error);
      return { success: false, message: '教師の追加に失敗しました。' };
    }
  };

  const handleUpdateTeacher = async (updatedTeacher) => {
    try {
      let finalTeacher = { ...updatedTeacher };
      if (updatedTeacher.password && !isPasswordHashed(updatedTeacher.password)) {
        const hashedPassword = await hashPassword(updatedTeacher.password);
        finalTeacher.password = hashedPassword;
      }
      await set(ref(database, `teachers/${updatedTeacher.id}`), finalTeacher);
      return { success: true };
    } catch (error) {
      console.error('教師情報の更新に失敗しました:', error);
      return { success: false, message: '教師情報の更新に失敗しました。' };
    }
  };

  const handleDeleteTeacher = async (id) => {
    try {
      await remove(ref(database, `teachers/${id}`));
      return { success: true };
    } catch (error) {
      console.error('教師の削除に失敗しました:', error);
      return { success: false, message: '教師の削除に失敗しました。' };
    }
  };

  return {
    handleAddTeacher,
    handleUpdateTeacher,
    handleDeleteTeacher
  };
}; 